export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

export const PHONE_REGEX = /[9,2,4]\d{8,20}$/

export const DATE_REGEX = /^(((0[1-9]|[12][0-9]|30)[/](0[13-9]|1[012])|31[/](0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[/]02)[/][0-9]{4}|29[/]02[/]([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/

export const PASSWORD_REGEX = /^(?=.*[\d])(?=.*[a-z])[\w!@€#=<>?.ªº~,$%(|/\\)"º\-^&*\u0021-\u017F]{6,}$/
